// Compact builders for writing preset templates by hand.
// All numbers are millimetres; font sizes are points.
let n = 0;
const id = (p) => `${p}_${(n++).toString(36)}`;

const st = (style = {}) => ({ fontSize: 8, align: "left", valign: "top", ...style });

// Static text with {{ formula }} placeholders and **bold** markup.
export const text = (x, y, w, h, content, style) => ({ id: id("tx"), type: "text", x, y, w, h, content, style: st(style) });

// A single formula / field value.
export const field = (x, y, w, h, expr, format = "", style, extra = {}) => ({ id: id("fd"), type: "field", x, y, w, h, expr, format, style: st(style), ...extra });

export const hline = (x, y, w, style = {}) => ({ id: id("ln"), type: "line", orientation: "h", x, y: y - 1, w, h: 2, style: { lineWidth: 0.75, color: "#000000", lineStyle: "solid", ...style } });

export const vline = (x, y, h, style = {}) => ({ id: id("ln"), type: "line", orientation: "v", x: x - 1, y, w: 2, h, style: { lineWidth: 0.75, color: "#000000", lineStyle: "solid", ...style } });

export const box = (x, y, w, h, style = {}) => ({ id: id("rc"), type: "rect", x, y, w, h, style: { borderWidth: 0.75, borderColor: "#000000", ...style } });

export const image = (x, y, w, h, srcExpr, extra = {}) => ({ id: id("im"), type: "image", x, y, w, h, src: "", srcExpr, fit: "contain", ...extra, style: st(extra.style) });

export const qr = (x, y, size, expr, extra = {}) => ({ id: id("qr"), type: "qr", x, y, w: size, h: size, expr, ecl: "M", ...extra, style: st(extra.style) });

export const barcode = (x, y, w, h, expr, extra = {}) => ({ id: id("bc"), type: "barcode", x, y, w, h, expr, showText: true, ...extra, style: st({ fontSize: 7, align: "center", ...(extra.style || {}) }) });

// Label on the left, right-aligned value on the right (for totals blocks).
export const pair = (x, y, w, label, expr, format = "money", style = {}) => [
  text(x, y, w * 0.6, 4.5, label, style),
  field(x + w * 0.4, y, w * 0.6, 4.5, expr, format, { ...style, align: "right" }),
];

export const col = (key, header, expr, width, extra = {}) => ({ id: id("c"), key, header, expr, width, align: "left", format: "", ...extra });

export const table = (name, source, x, w, columns, extra = {}) => ({
  id: id("tb"),
  type: "table",
  name,
  source,
  x,
  w,
  showHeader: true,
  repeatHeader: true,
  showFooter: false,
  minRows: 0,
  filter: "",
  sortBy: "",
  sortDir: "asc",
  columns,
  ...extra,
  style: { fontSize: 7.5, grid: "all", borderWidth: 0.5, borderColor: "#000000", cellPadding: 0.8, valign: "top", ...(extra.style || {}) },
  headerStyle: { bold: true, ...(extra.headerStyle || {}) },
  footerStyle: { bold: true, ...(extra.footerStyle || {}) },
});

export const fixedBand = (name, height, elements, extra = {}) => ({ id: id("bd"), type: "fixed", name, height, repeat: "none", elements: elements.flat(), ...extra });

export const tableBand = (name, tbl, extra = {}) => ({ id: id("bd"), type: "table", name, paddingTop: 0, paddingBottom: 0, elements: [tbl], ...extra });

export const a4 = (margins = 8) => ({ preset: "A4", width: 210, height: 297, orientation: "portrait", continuous: false, margins: { top: margins, right: margins, bottom: margins, left: margins } });

export const thermal = (preset, width) => ({ preset, width, height: 0, orientation: "portrait", continuous: true, margins: { top: 2, right: width <= 58 ? 5 : 4, bottom: 4, left: width <= 58 ? 5 : 4 } });

export const preset = (docType, name, paper, bands, extra = {}) => ({
  version: 1,
  docType,
  name,
  paper,
  defaults: { fontFamily: "Arial", fontSize: 8, color: "#000000" },
  variables: [],
  bands,
  ...extra,
});
